import { Layout } from "../models/layout";

const SMALL_DEVICE_THRETHOLD = 375;
const initialState: Layout = {
  screenWidth: 375,
  screenHeight: 500,
  isSmallDevice: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case "SET_SCREEN_SIZE":
      return {
        screenWidth: action.payload.width,
        screenHeight: action.payload.height,
        isSmallDevice: Boolean(action.payload.width < SMALL_DEVICE_THRETHOLD)
      };
    default:
      return state;
  }
}
